// extracted by mini-css-extract-plugin
export default {"tooltip":"_V-z","arrow":"aW-z"};